import Table from "../../components/Table";
import BasicButton from "components/BasicInputs/BasicButton";
import { useNavigate } from "react-router-dom";
export default function Factors() {
  return <Table type="factor" sumAmountInfo={[{ name: "totalPrice", isCurrency: true }]}
  />;
}

function ActionSection({ selectedItems }) {
  const navigate = useNavigate();
  return (
    <BasicButton
      variant="contained"
      onClick={() => {
        navigate("/transactions/add", {
          state: { factorIds: selectedItems },
        });
      }}
    >
      <span>تسویه</span>
    </BasicButton>
  );
}
